import { graphql, readInlineData } from "react-relay";

import type { helpersSectionMenuQuery$key } from "scmp-app/queries/__generated__/helpersSectionMenuQuery.graphql";

import { SectionOptions } from "./const";

export type SectionOptionWithCount = {
  count: string;
  text: string;
  value: string;
};

export function getSectionOptionsWithCount(
  fragmentReference: helpersSectionMenuQuery$key,
): SectionOptionWithCount[] {
  const data = readInlineData(
    graphql`
      fragment helpersSectionMenuQuery on Query @inline {
        articleSearchV2(
          filter: {
            query: $query
            sectionIds: $sectionIds
            articleTypes: $articleTypeIds
            paywallTypeIds: $paywallTypeIds
            contentTypes: $contentTypes
            startDate: $startDate
            endDate: $endDate
          }
          orderBy: $orderBy
          first: $first
          after: $after
        ) {
          aggregations {
            section {
              buckets {
                key
                doc_count
              }
            }
          }
        }
      }
    `,
    fragmentReference,
  );

  const buckets = data.articleSearchV2?.aggregations?.section?.buckets ?? [];

  return [
    {
      count: "",
      text: "All",
      value: "",
    },
    ...SectionOptions.map(option => {
      const matched = buckets.find(bucket => bucket.key === option.value);
      return {
        ...option,
        count: matched?.doc_count.toLocaleString() ?? "",
      };
    }),
  ];
}
